export default __webpack_public_path__ + "static/media/OrangePlus.b4f1a298.svg";